// Libellés métier cohérents selon l'opération — utilisé dans le wizard,
// la fiche bien et les listes. Unique source de vérité côté UI.

// M11 — Libellé du champ Prix selon l'opération
export const getPriceLabel = (operation) => {
  switch (operation) {
    case 'cession':
      return 'Prix de cession (€)';
    case 'vente_immo':
      return 'Prix de vente (€)';
    case 'location':
      return 'Loyer mensuel HT (€)';
    case 'location_droit_entree':
      return 'Loyer HT (€/mois)';
    case 'location_gerance':
      return 'Redevance mensuelle (€)';
    default:
      return 'Prix / Loyer (€)';
  }
};

// M12 — Libellé de l'acteur propriétaire selon l'opération
export const getOwnerLabel = (operation) => {
  switch (operation) {
    case 'cession':
      return 'Cédant';
    case 'vente_immo':
      return 'Vendeur';
    case 'location':
    case 'location_droit_entree':
      return 'Bailleur';
    case 'location_gerance':
      return 'Propriétaire du fonds';
    default:
      return 'Propriétaire';
  }
};

// Micro-copy descriptive pour chaque acteur
export const getOwnerHelper = (operation) => {
  switch (operation) {
    case 'cession':
      return 'Personne ou société qui cède le fonds de commerce.';
    case 'vente_immo':
      return 'Personne ou société qui vend le bien immobilier.';
    case 'location':
    case 'location_droit_entree':
      return 'Personne ou société propriétaire qui met le local en location.';
    case 'location_gerance':
      return 'Personne ou société propriétaire du fonds mis en location-gérance.';
    default:
      return 'Contact principal lié au bien.';
  }
};
